(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800,858,8063],{

/***/ 73276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(35923);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98456);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 83594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73755);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31654);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4134);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72275);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25039);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12331);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26428);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55549);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 84169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5848);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3075);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21697);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 93298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SettingsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50858);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10687);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_settings_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61730);





function SettingsContainer(param) {
    let { children  } = param;
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sidebar),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                withLinks: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().line)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().body),
                    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child)=>child ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child) : null)
                })
            ]
        })
    });
}


/***/ }),

/***/ 50858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(38027);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27735);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99954);
/* harmony import */ var remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31041);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54762);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97169);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13597);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var utils_scrollToView__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56131);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29969);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40367);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83594);
/* harmony import */ var constants_features__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81800);
















 // ✅ flag funzionalità
function Sidebar(param) {
    let { data , withLinks =false , onClose  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { query , pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const { logout , isAuthenticated , openAuthModal  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)();
    const links = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(()=>{
        if (isAuthenticated) {
            return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_13__/* .profileDropdownLinks.filter */ .a.filter((item)=>item.href !== "/shop");
        }
        return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_13__/* .profileDropdownLinks.filter */ .a.filter((item)=>!item.requiredAuth && item.href !== "/shop");
    }, [
        isAuthenticated
    ]);
    const handleLogout = ()=>{
        logout();
    };
    const handleClose = ()=>{
        if (onClose) {
            onClose();
        }
    };
    const renderAuthButton = ()=>{
        if (!isAuthenticated) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link),
                onClick: ()=>openAuthModal(),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_11___default()), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                        size: 20
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: "button",
            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link),
            onClick: handleLogout,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("log.out")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                    size: 20
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/shop",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link), " ").concat(pathname === "/shop" && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("shops")
                                })
                            ]
                        })
                    }),
                    constants_features__WEBPACK_IMPORTED_MODULE_14__/* ["default"].recipes */ .Z.recipes && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: {
                            pathname: "/recipes",
                            query: {
                                shop_id: query === null || query === void 0 ? void 0 : query.id
                            }
                        },
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link), " ").concat(pathname.includes("/recipes") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("recipes")
                                })
                            ]
                        })
                    }),
                    !withLinks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: {
                            pathname: "/liked/products",
                            query: {
                                shop_id: query === null || query === void 0 ? void 0 : query.id
                            }
                        },
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link), " ").concat(pathname.includes("/liked/products") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("liked.products")
                                })
                            ]
                        })
                    }),
                    withLinks && links.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: item.href,
                            className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link), " ").concat(pathname === item.href && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t(item.label)
                                    })
                                ]
                            })
                        }, item.href))
                ]
            }),
            !!(data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().categoryContainer),
                children: data === null || data === void 0 ? void 0 : data.map((category)=>{
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: ()=>{
                            return (0,utils_scrollToView__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(category === null || category === void 0 ? void 0 : category.uuid, -70);
                        },
                        type: "button",
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().category),
                        children: category === null || category === void 0 ? void 0 : (ref = category.translation) === null || ref === void 0 ? void 0 : ref.title
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/help",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link), " ").concat(pathname.includes("/help") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_15___default().body),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t("help.center")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                                size: 20
                            })
                        ]
                    }),
                    renderAuthButton()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 2950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21697);


function useUserLocation() {
    const { location: userLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    const location = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const latlng = userLocation;
        if (!latlng) {
            return undefined;
        }
        return {
            latitude: latlng.split(",")[0],
            longitude: latlng.split(",")[1]
        };
    }, [
        userLocation
    ]);
    return location;
}


/***/ }),

/***/ 35923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Shops; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(84169);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(1612);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/category.ts
var category = __webpack_require__(56457);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(2950);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(18074);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(94627);
;// CONCATENATED MODULE: ./containers/shops/shopsPage.tsx











const ZoneNotFound = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3135).then(__webpack_require__.bind(__webpack_require__, 3135)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3135)
            ]
    }
});
const ShopList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9526), __webpack_require__.e(9360), __webpack_require__.e(936), __webpack_require__.e(5587)]).then(__webpack_require__.bind(__webpack_require__, 20936)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20936)
            ]
    }
});
const ShopCategoryList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9526), __webpack_require__.e(719), __webpack_require__.e(1482)]).then(__webpack_require__.bind(__webpack_require__, 1482)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1482)
            ]
    }
});
function ShopsPage() {
    var ref, ref1;
    const { t , locale  } = (0,useLocale/* default */.Z)();
    const { query  } = (0,router.useRouter)();
    const loader = (0,react.useRef)(null);
    const location = (0,useUserLocation/* default */.Z)();
    const { isSuccess: isInsideZone , isLoading: isZoneLoading  } = (0,es.useQuery)([
        "shopZones",
        location
    ], ()=>shop/* default.checkZone */.Z.checkZone({
            address: location
        }));
    const { data , fetchNextPage , hasNextPage , isFetchingNextPage , isLoading  } = (0,es.useInfiniteQuery)([
        "shops",
        locale,
        location,
        query === null || query === void 0 ? void 0 : query.category_id
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.getAll */.Z.getAll(lib_default().stringify({
            page: pageParam,
            perPage: 12,
            address: location,
            category_id: (query === null || query === void 0 ? void 0 : query.category_id) || undefined
        }));
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        }
    });
    const { data: shopCategoryList , isLoading: shopCategoryLoading  } = (0,es.useQuery)([
        "shopCategories",
        locale
    ], ()=>category/* default.getAllShopCategories */.Z.getAllShopCategories({
            perPage: 20
        }));
    const handleObserver = (0,react.useCallback)((entries)=>{
        const target = entries[0];
        if (target.isIntersecting && hasNextPage) {
            fetchNextPage();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(()=>{
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current);
    }, [
        handleObserver
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCategoryList, {
                data: (shopCategoryList === null || shopCategoryList === void 0 ? void 0 : (ref = shopCategoryList.data) === null || ref === void 0 ? void 0 : ref.sort((a, b)=>{
                    return (a === null || a === void 0 ? void 0 : a.input) - (b === null || b === void 0 ? void 0 : b.input);
                })) || [],
                loading: shopCategoryLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopList, {
                title: t("stores"),
                shops: (data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap((item)=>item.data)) || [],
                loading: isLoading && !isFetchingNextPage
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                        onClick: fetchNextPage,
                        loading: isFetchingNextPage,
                        children: t("load.more")
                    })
                ]
            }),
            !isInsideZone && !isZoneLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoneNotFound, {})
        ]
    });
}

// EXTERNAL MODULE: ./containers/settings/settings.tsx
var settings = __webpack_require__(93298);
;// CONCATENATED MODULE: ./pages/shop/index.tsx




function Shops() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(settings/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopsPage, {})
            })
        ]
    });
}


/***/ }),

/***/ 56457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const categoryService = {
    getAllShopCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "shop"
            }
        });
    },
    getAllSubCategories: function(categoryId) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/categories/sub-shop/".concat(categoryId), {
            params
        });
    },
    getAllProductCategories: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/categories"), {
            params
        }),
    getAllRecipeCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "receipt"
            }
        });
    },
    getById: function(id) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/".concat(id), {
            params
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (categoryService);


/***/ }),

/***/ 1612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    // getAllBooking: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/booking/shops/paginate?${params}`),
    // getAllRestaurants: (params: string): Promise<Paginate<IBookingShop>> =>
    //   request.get(`/rest/shops/paginate?type=restaurant&${params}`),
    // getAllShops: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/shops/paginate?type=shop&${params}`),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 56131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToView; }
/* harmony export */ });
function scrollToView(uuid) {
    let yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!uuid) {
        return;
    }
    const element = document.getElementById(uuid);
    if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    } else {
        var ref, ref1;
        window.location.hash = uuid;
        const element1 = document.getElementById("the-end");
        const y1 = (element1 === null || element1 === void 0 ? void 0 : (ref = element1.getBoundingClientRect) === null || ref === void 0 ? void 0 : (ref1 = ref.call(element1)) === null || ref1 === void 0 ? void 0 : ref1.top) + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y1,
            behavior: "smooth"
        });
    }
}


/***/ }),

/***/ 10687:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__rObHi","sidebar":"settings_sidebar____hs3","line":"settings_line__zzjer","body":"settings_body__uMN7T"};

/***/ }),

/***/ 38027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar_container__IjaDC","links":"sidebar_links__LM_pw","link":"sidebar_link__6YsEF","body":"sidebar_body__cwbZC","active":"sidebar_active__rrguH","categoryContainer":"sidebar_categoryContainer__3wSEp","category":"sidebar_category__b_8_c"};

/***/ }),

/***/ 97169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8300,2092,9774,2888,179], function() { return __webpack_exec__(73276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);